import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  Companion_getInstance1atejy3oe81if as Companion_getInstance,
  ClosureReason_Holiday_getInstance1gv01vuec049b as ClosureReason_Holiday_getInstance,
  ClosureReason_Flexible_getInstance1hg43z0nox243 as ClosureReason_Flexible_getInstance,
  ClosureReason_ProfessionalDevelopment_getInstancecpxpkronpmjz as ClosureReason_ProfessionalDevelopment_getInstance,
  ClosureReason_Emergency_getInstance2e06kp9fjoz8u as ClosureReason_Emergency_getInstance,
  ClosureReason_Unapproved_getInstance8leekbk2k7d1 as ClosureReason_Unapproved_getInstance,
} from './domain.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { toSet2orjxp16sotqu as toSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function CareTime$Companion$_anonymous__6fj7v5() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.CareTime', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  Type_BeforeAfter_instance = new (Type())('BeforeAfter', 0, 'Before / After School');
  Type_PartFull_instance = new (Type())('PartFull', 1, 'Part / Full Time');
}
var Type_BeforeAfter_instance;
var Type_PartFull_instance;
var static_init_called_0;
function static_init_0() {
  if (static_init_called_0)
    return Unit_instance;
  static_init_called_0 = true;
  CareTime_BeforeSchool_instance = new (CareTime())('BeforeSchool', 0, 'Before School', 'BS', Type_BeforeAfter_getInstance());
  CareTime_AfterSchool_instance = new (CareTime())('AfterSchool', 1, 'After School', 'AS', Type_BeforeAfter_getInstance());
  CareTime_BeforeAndAfterSchool_instance = new (CareTime())('BeforeAndAfterSchool', 2, 'Before And After School', 'BA', Type_BeforeAfter_getInstance());
  CareTime_FullTime_instance = new (CareTime())('FullTime', 3, 'Full Time', 'FT', Type_PartFull_getInstance());
  CareTime_PartTime_instance = new (CareTime())('PartTime', 4, 'Part Time', 'PT', Type_PartFull_getInstance());
  if (Companion_instance_0 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var CareTime_BeforeSchool_instance;
var CareTime_AfterSchool_instance;
var CareTime_BeforeAndAfterSchool_instance;
var CareTime_FullTime_instance;
var CareTime_PartTime_instance;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, CareTime$Companion$_anonymous__6fj7v5);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  static_init_0();
  return Companion_instance_0;
}
var TypeClass;
function Type() {
  if (TypeClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName) {
        super(name, ordinal);
        this.displayName_1 = displayName;
      }
    }
    initMetadataForClass($, 'Type');
    TypeClass = $;
  }
  return TypeClass;
}
function values() {
  static_init_0();
  return [CareTime_BeforeSchool_getInstance(), CareTime_AfterSchool_getInstance(), CareTime_BeforeAndAfterSchool_getInstance(), CareTime_FullTime_getInstance(), CareTime_PartTime_getInstance()];
}
function get_entries() {
  static_init_0();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
function Type_BeforeAfter_getInstance() {
  static_init();
  static_init_0();
  return Type_BeforeAfter_instance;
}
function Type_PartFull_getInstance() {
  static_init();
  static_init_0();
  return Type_PartFull_instance;
}
var $ENTRIES;
var CareTimeClass;
function CareTime() {
  if (CareTimeClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName, code, type) {
        super(name, ordinal);
        this.displayName_1 = displayName;
        this.code_1 = code;
        this.type_1 = type;
      }
    }
    initMetadataForClass($, 'CareTime', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    CareTimeClass = $;
  }
  return CareTimeClass;
}
function ActualAttendance$Companion$$childSerializers$_anonymous__mrfndf() {
  return Companion_getInstance_4().serializer_9w0wvi_k$();
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, ActualAttendance$Companion$$childSerializers$_anonymous__mrfndf), null, null, null];
        this.PLACEHOLDER_1 = ActualAttendance().new_org_thecommunitygroupinc_cares_ActualAttendance_33pfhi_k$(new (ScheduledAttendance())(CareTime_FullTime_getInstance()), AttendanceCase_Attended_getInstance());
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new (Companion_0())();
  return Companion_instance_1;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.ActualAttendance', this, 5);
        tmp0_serialDesc.addElement_5pzumi_k$('scheduled', false);
        tmp0_serialDesc.addElement_5pzumi_k$('case', false);
        tmp0_serialDesc.addElement_5pzumi_k$('useIntermittent', true);
        tmp0_serialDesc.addElement_5pzumi_k$('transportTo', true);
        tmp0_serialDesc.addElement_5pzumi_k$('transportFrom', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_6qumlo_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_0(), value.scheduled_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.case_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.useIntermittent_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 2, value.useIntermittent_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.transportTo_1 === value.scheduled_1.transportTo_1)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 3, value.transportTo_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.transportFrom_1 === value.scheduled_1.transportFrom_1)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 4, value.transportFrom_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_6qumlo_k$(encoder, value instanceof ActualAttendance() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = false;
        var tmp7_local3 = false;
        var tmp8_local4 = false;
        var tmp9_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp10_cached = Companion_getInstance_1().$childSerializers_1;
        if (tmp9_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer_getInstance_0(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp10_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer_getInstance_0(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp10_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp9_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ActualAttendance().new_org_thecommunitygroupinc_cares_ActualAttendance_ovksto_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_1().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_0(), tmp0_cached[1].get_value_j01efc_k$(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var ActualAttendanceClass;
function ActualAttendance() {
  if (ActualAttendanceClass === VOID) {
    class $ {
      constructor(scheduled, case_0, useIntermittent, transportTo, transportFrom) {
        return new.target.new_org_thecommunitygroupinc_cares_ActualAttendance_33pfhi_k$(scheduled, case_0, useIntermittent, transportTo, transportFrom);
      }
      static new_org_thecommunitygroupinc_cares_ActualAttendance_33pfhi_k$(scheduled, case_0, useIntermittent, transportTo, transportFrom) {
        Companion_getInstance_1();
        useIntermittent = useIntermittent === VOID ? false : useIntermittent;
        transportTo = transportTo === VOID ? scheduled.transportTo_1 : transportTo;
        transportFrom = transportFrom === VOID ? scheduled.transportFrom_1 : transportFrom;
        var $this = createThis(this);
        $this.scheduled_1 = scheduled;
        $this.case_1 = case_0;
        $this.useIntermittent_1 = useIntermittent;
        $this.transportTo_1 = transportTo;
        $this.transportFrom_1 = transportFrom;
        // Inline function 'kotlin.require' call
        if (!(!$this.useIntermittent_1 || !($this.scheduled_1.timeWhenIntermittent_1 == null))) {
          var message = 'The placement is not intermittent on this day, so school being out changes nothing.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!($this.case_1.before_1 == null || $this.scheduled_1.time_1.equals(CareTime_BeforeAndAfterSchool_getInstance()))) {
          var message_0 = 'Half day absences only apply to a before-and-after school day, not ' + toString($this.scheduled_1.time_1) + '.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
        // Inline function 'kotlin.require' call
        if (!($this.case_1.before_1 == null || !$this.useIntermittent_1)) {
          var message_1 = 'A half day absence is a school day; school cannot also be out.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_1));
        }
        // Inline function 'kotlin.require' call
        if (!((!$this.transportTo_1 || $this.scheduled_1.transportTo_1) && (!$this.transportFrom_1 || $this.scheduled_1.transportFrom_1))) {
          var message_2 = 'Transport was recorded that the placement does not authorise.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_2));
        }
        return $this;
      }
      static new_org_thecommunitygroupinc_cares_ActualAttendance_uhejyj_k$(expected, case_0, useIntermittent) {
        Companion_getInstance_1();
        useIntermittent = useIntermittent === VOID ? false : useIntermittent;
        var $this = this.new_org_thecommunitygroupinc_cares_ActualAttendance_33pfhi_k$(expected.scheduled_1, case_0, useIntermittent);
        // Inline function 'kotlin.require' call
        if (!expected.get_options_jecmyz_k$().contains_aljjnj_k$(case_0)) {
          var message = toString(case_0) + ' cannot be recorded against ' + expected.toString() + '.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        return $this;
      }
      get_billedTime_8fk3ac_k$() {
        return this.useIntermittent_1 ? ensureNotNull(this.scheduled_1.timeWhenIntermittent_1) : this.scheduled_1.time_1;
      }
      get_transportCount_67vxxt_k$() {
        return (this.transportTo_1 ? 1 : 0) + (this.transportFrom_1 ? 1 : 0) | 0;
      }
      get_massachusettsAttendanceCode_3eo4hh_k$() {
        var partTimeIntermittent = equals(this.scheduled_1.timeWhenIntermittent_1, CareTime_PartTime_getInstance());
        var tmp;
        switch (this.case_1.ordinal_1) {
          case 4:
            tmp = Kind_UC_getInstance();
            break;
          case 0:
          case 3:
          case 1:
          case 2:
            tmp = this.useIntermittent_1 ? Kind_IC_getInstance() : this.get_billedTime_8fk3ac_k$().equals(CareTime_PartTime_getInstance()) ? Kind_CP_getInstance() : Kind_CF_getInstance();
            break;
          case 5:
            tmp = this.useIntermittent_1 ? Kind_IEN_getInstance() : Kind_EN_getInstance();
            break;
          case 6:
            tmp = !this.useIntermittent_1 ? Kind_EA_getInstance() : partTimeIntermittent ? Kind_IPEA_getInstance() : Kind_IFEA_getInstance();
            break;
          case 7:
            tmp = !this.useIntermittent_1 ? Kind_UA_getInstance() : partTimeIntermittent ? Kind_IPUA_getInstance() : Kind_IFUA_getInstance();
            break;
          case 8:
            tmp = Kind_BSEA_getInstance();
            break;
          case 9:
            tmp = Kind_BSUA_getInstance();
            break;
          case 10:
            tmp = Kind_ASEA_getInstance();
            break;
          case 11:
            tmp = Kind_ASUA_getInstance();
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var kind = tmp;
        return new (MassachusettsAttendanceCode())(kind, this.get_transportCount_67vxxt_k$());
      }
      copy_l3tiwk_k$(scheduled, case_0, useIntermittent, transportTo, transportFrom) {
        return ActualAttendance().new_org_thecommunitygroupinc_cares_ActualAttendance_33pfhi_k$(scheduled, case_0, useIntermittent, transportTo, transportFrom);
      }
      copy$default_hj90z6_k$(scheduled, case_0, useIntermittent, transportTo, transportFrom, $super) {
        scheduled = scheduled === VOID ? this.scheduled_1 : scheduled;
        case_0 = case_0 === VOID ? this.case_1 : case_0;
        useIntermittent = useIntermittent === VOID ? this.useIntermittent_1 : useIntermittent;
        transportTo = transportTo === VOID ? this.transportTo_1 : transportTo;
        transportFrom = transportFrom === VOID ? this.transportFrom_1 : transportFrom;
        return $super === VOID ? this.copy_l3tiwk_k$(scheduled, case_0, useIntermittent, transportTo, transportFrom) : $super.copy_l3tiwk_k$.call(this, scheduled, case_0, useIntermittent, transportTo, transportFrom);
      }
      toString() {
        return 'ActualAttendance(scheduled=' + this.scheduled_1.toString() + ', case=' + toString(this.case_1) + ', useIntermittent=' + this.useIntermittent_1 + ', transportTo=' + this.transportTo_1 + ', transportFrom=' + this.transportFrom_1 + ')';
      }
      hashCode() {
        var result = this.scheduled_1.hashCode();
        result = imul(result, 31) + this.case_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.useIntermittent_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.transportTo_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.transportFrom_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ActualAttendance()))
          return false;
        if (!this.scheduled_1.equals(other.scheduled_1))
          return false;
        if (!this.case_1.equals(other.case_1))
          return false;
        if (!(this.useIntermittent_1 === other.useIntermittent_1))
          return false;
        if (!(this.transportTo_1 === other.transportTo_1))
          return false;
        if (!(this.transportFrom_1 === other.transportFrom_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_ActualAttendance_ovksto_k$(seen0, scheduled, case_0, useIntermittent, transportTo, transportFrom, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        $this.scheduled_1 = scheduled;
        $this.case_1 = case_0;
        if (0 === (seen0 & 4))
          $this.useIntermittent_1 = false;
        else
          $this.useIntermittent_1 = useIntermittent;
        if (0 === (seen0 & 8))
          $this.transportTo_1 = $this.scheduled_1.transportTo_1;
        else
          $this.transportTo_1 = transportTo;
        if (0 === (seen0 & 16))
          $this.transportFrom_1 = $this.scheduled_1.transportFrom_1;
        else
          $this.transportFrom_1 = transportFrom;
        // Inline function 'kotlin.require' call
        if (!(!$this.useIntermittent_1 || !($this.scheduled_1.timeWhenIntermittent_1 == null))) {
          var message = 'The placement is not intermittent on this day, so school being out changes nothing.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!($this.case_1.before_1 == null || $this.scheduled_1.time_1.equals(CareTime_BeforeAndAfterSchool_getInstance()))) {
          var message_0 = 'Half day absences only apply to a before-and-after school day, not ' + toString($this.scheduled_1.time_1) + '.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
        // Inline function 'kotlin.require' call
        if (!($this.case_1.before_1 == null || !$this.useIntermittent_1)) {
          var message_1 = 'A half day absence is a school day; school cannot also be out.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_1));
        }
        // Inline function 'kotlin.require' call
        if (!((!$this.transportTo_1 || $this.scheduled_1.transportTo_1) && (!$this.transportFrom_1 || $this.scheduled_1.transportFrom_1))) {
          var message_2 = 'Transport was recorded that the placement does not authorise.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_2));
        }
        return $this;
      }
    }
    initMetadataForClass($, 'ActualAttendance', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    ActualAttendanceClass = $;
  }
  return ActualAttendanceClass;
}
function ScheduledAttendance$Companion$$childSerializers$_anonymous__4hzh10() {
  return Companion_getInstance_0().serializer_9w0wvi_k$();
}
function ScheduledAttendance$Companion$$childSerializers$_anonymous__4hzh10_0() {
  return Companion_getInstance_0().serializer_9w0wvi_k$();
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ScheduledAttendance$Companion$$childSerializers$_anonymous__4hzh10);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [tmp_1, null, null, lazy(tmp_2, ScheduledAttendance$Companion$$childSerializers$_anonymous__4hzh10_0)];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  if (Companion_instance_2 === VOID)
    new (Companion_1())();
  return Companion_instance_2;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.ScheduledAttendance', this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('time', false);
        tmp0_serialDesc.addElement_5pzumi_k$('transportFrom', true);
        tmp0_serialDesc.addElement_5pzumi_k$('transportTo', true);
        tmp0_serialDesc.addElement_5pzumi_k$('timeWhenIntermittent', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_creouz_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, tmp2_cached[0].get_value_j01efc_k$(), value.time_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.transportFrom_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 1, value.transportFrom_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.transportTo_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 2, value.transportTo_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.timeWhenIntermittent_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, tmp2_cached[3].get_value_j01efc_k$(), value.timeWhenIntermittent_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_creouz_k$(encoder, value instanceof ScheduledAttendance() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp6_local2 = false;
        var tmp7_local3 = null;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp9_cached = Companion_getInstance_2().$childSerializers_1;
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp9_cached[0].get_value_j01efc_k$(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, tmp9_cached[3].get_value_j01efc_k$(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp9_cached[0].get_value_j01efc_k$(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, tmp9_cached[3].get_value_j01efc_k$(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ScheduledAttendance().new_org_thecommunitygroupinc_cares_ScheduledAttendance_wd8u6i_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_2().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].get_value_j01efc_k$(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(tmp0_cached[3].get_value_j01efc_k$())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var ScheduledAttendanceClass;
function ScheduledAttendance() {
  if (ScheduledAttendanceClass === VOID) {
    class $ {
      constructor(time, transportFrom, transportTo, timeWhenIntermittent) {
        Companion_getInstance_2();
        transportFrom = transportFrom === VOID ? false : transportFrom;
        transportTo = transportTo === VOID ? false : transportTo;
        timeWhenIntermittent = timeWhenIntermittent === VOID ? null : timeWhenIntermittent;
        this.time_1 = time;
        this.transportFrom_1 = transportFrom;
        this.transportTo_1 = transportTo;
        this.timeWhenIntermittent_1 = timeWhenIntermittent;
        // Inline function 'kotlin.require' call
        if (!(this.timeWhenIntermittent_1 == null || this.timeWhenIntermittent_1.type_1.equals(Type_PartFull_getInstance()))) {
          var message = 'A day school is out bills full or part time, not ' + toString_0(this.timeWhenIntermittent_1) + '.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(this.timeWhenIntermittent_1 == null || !this.time_1.equals(CareTime_FullTime_getInstance()))) {
          var message_0 = "Intermittent care is more care on a day school is out; a full time schedule already gets the most care there is, so there's nothing to bump up to.";
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
        // Inline function 'kotlin.require' call
        if (!(this.timeWhenIntermittent_1 == null || !equals(this.timeWhenIntermittent_1, this.time_1))) {
          var message_1 = "Intermittent care that bills the same as the regular schedule changes nothing, so it isn't intermittent.";
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_1));
        }
      }
      toString() {
        return 'ScheduledAttendance(time=' + toString(this.time_1) + ', transportFrom=' + this.transportFrom_1 + ', transportTo=' + this.transportTo_1 + ', timeWhenIntermittent=' + toString_0(this.timeWhenIntermittent_1) + ')';
      }
      hashCode() {
        var result = this.time_1.hashCode();
        result = imul(result, 31) + getBooleanHashCode(this.transportFrom_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.transportTo_1) | 0;
        result = imul(result, 31) + (this.timeWhenIntermittent_1 == null ? 0 : this.timeWhenIntermittent_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ScheduledAttendance()))
          return false;
        if (!this.time_1.equals(other.time_1))
          return false;
        if (!(this.transportFrom_1 === other.transportFrom_1))
          return false;
        if (!(this.transportTo_1 === other.transportTo_1))
          return false;
        if (!equals(this.timeWhenIntermittent_1, other.timeWhenIntermittent_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_ScheduledAttendance_wd8u6i_k$(seen0, time, transportFrom, transportTo, timeWhenIntermittent, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_0().descriptor_1);
        }
        var $this = createThis(this);
        $this.time_1 = time;
        if (0 === (seen0 & 2))
          $this.transportFrom_1 = false;
        else
          $this.transportFrom_1 = transportFrom;
        if (0 === (seen0 & 4))
          $this.transportTo_1 = false;
        else
          $this.transportTo_1 = transportTo;
        if (0 === (seen0 & 8))
          $this.timeWhenIntermittent_1 = null;
        else
          $this.timeWhenIntermittent_1 = timeWhenIntermittent;
        // Inline function 'kotlin.require' call
        if (!($this.timeWhenIntermittent_1 == null || $this.timeWhenIntermittent_1.type_1.equals(Type_PartFull_getInstance()))) {
          var message = 'A day school is out bills full or part time, not ' + toString_0($this.timeWhenIntermittent_1) + '.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!($this.timeWhenIntermittent_1 == null || !$this.time_1.equals(CareTime_FullTime_getInstance()))) {
          var message_0 = "Intermittent care is more care on a day school is out; a full time schedule already gets the most care there is, so there's nothing to bump up to.";
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
        // Inline function 'kotlin.require' call
        if (!($this.timeWhenIntermittent_1 == null || !equals($this.timeWhenIntermittent_1, $this.time_1))) {
          var message_1 = "Intermittent care that bills the same as the regular schedule changes nothing, so it isn't intermittent.";
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_1));
        }
        return $this;
      }
    }
    initMetadataForClass($, 'ScheduledAttendance', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    ScheduledAttendanceClass = $;
  }
  return ScheduledAttendanceClass;
}
function ExpectedAttendance$Companion$$childSerializers$_anonymous__a8bbmf() {
  return Companion_getInstance().serializer_9w0wvi_k$();
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, ExpectedAttendance$Companion$$childSerializers$_anonymous__a8bbmf)];
      }
      of_tn5enx_k$(placement, date, closure, programs) {
        if (!placement.activeRange_1.contains_pio7lx_k$(date))
          return null;
        var tmp0_elvis_lhs = placement.schedule_1.get_riprg6_k$(date.get_dayOfWeek_3kfgci_k$());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var day = tmp;
        return new (ExpectedAttendance())(day.scheduled_uf1us3_k$(programs), closure);
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 === VOID)
    new (Companion_2())();
  return Companion_instance_3;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.ExpectedAttendance', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('scheduled', false);
        tmp0_serialDesc.addElement_5pzumi_k$('closure', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_776nrq_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_3().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_0(), value.scheduled_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.closure_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.closure_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_776nrq_k$(encoder, value instanceof ExpectedAttendance() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp7_cached = Companion_getInstance_3().$childSerializers_1;
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer_getInstance_0(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, tmp7_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer_getInstance_0(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, tmp7_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ExpectedAttendance().new_org_thecommunitygroupinc_cares_ExpectedAttendance_n1p0an_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_3().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_0(), get_nullable(tmp0_cached[1].get_value_j01efc_k$())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var ExpectedAttendanceClass;
function ExpectedAttendance() {
  if (ExpectedAttendanceClass === VOID) {
    class $ {
      constructor(scheduled, closure) {
        Companion_getInstance_3();
        closure = closure === VOID ? null : closure;
        this.scheduled_1 = scheduled;
        this.closure_1 = closure;
      }
      get_options_jecmyz_k$() {
        var tmp0_subject = this.closure_1;
        var tmp;
        if ((tmp0_subject == null ? -1 : tmp0_subject.ordinal_1) === -1) {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = get_entries_0();
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (element.closureReason_1 == null && (element.before_1 == null || this.scheduled_1.time_1.equals(CareTime_BeforeAndAfterSchool_getInstance()))) {
              destination.add_utx5q5_k$(element);
            }
          }
          tmp = destination;
        } else {
          tmp = listOf(Companion_getInstance_4().forClosure_lt4mvc_k$(this.closure_1));
        }
        return tmp;
      }
      get_asScheduledCase_p11tha_k$() {
        var tmp0_safe_receiver = this.closure_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = Companion_getInstance_4().forClosure_lt4mvc_k$(tmp0_safe_receiver);
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? AttendanceCase_Attended_getInstance() : tmp1_elvis_lhs;
      }
      toString() {
        return 'ExpectedAttendance(scheduled=' + this.scheduled_1.toString() + ', closure=' + toString_0(this.closure_1) + ')';
      }
      hashCode() {
        var result = this.scheduled_1.hashCode();
        result = imul(result, 31) + (this.closure_1 == null ? 0 : this.closure_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ExpectedAttendance()))
          return false;
        if (!this.scheduled_1.equals(other.scheduled_1))
          return false;
        if (!equals(this.closure_1, other.closure_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_ExpectedAttendance_n1p0an_k$(seen0, scheduled, closure, serializationConstructorMarker) {
        Companion_getInstance_3();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_1().descriptor_1);
        }
        var $this = createThis(this);
        $this.scheduled_1 = scheduled;
        if (0 === (seen0 & 2))
          $this.closure_1 = null;
        else
          $this.closure_1 = closure;
        return $this;
      }
    }
    initMetadataForClass($, 'ExpectedAttendance', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    ExpectedAttendanceClass = $;
  }
  return ExpectedAttendanceClass;
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function AttendanceCase$Companion$_anonymous__fpe26u() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.AttendanceCase', values_0());
}
var static_init_called_1;
function static_init_1() {
  if (static_init_called_1)
    return Unit_instance;
  static_init_called_1 = true;
  AttendanceCase_ClosureHoliday_instance = new (AttendanceCase())('ClosureHoliday', 0, 'Closed (holiday)', ClosureReason_Holiday_getInstance());
  AttendanceCase_ClosureFlexible_instance = new (AttendanceCase())('ClosureFlexible', 1, 'Closed (flexible)', ClosureReason_Flexible_getInstance());
  AttendanceCase_ClosureProfessionalDevelopment_instance = new (AttendanceCase())('ClosureProfessionalDevelopment', 2, 'Closed (professional)', ClosureReason_ProfessionalDevelopment_getInstance());
  AttendanceCase_ClosureEmergency_instance = new (AttendanceCase())('ClosureEmergency', 3, 'Closed (emergency)', ClosureReason_Emergency_getInstance());
  AttendanceCase_ClosureUnapproved_instance = new (AttendanceCase())('ClosureUnapproved', 4, 'Closed (unapproved)', ClosureReason_Unapproved_getInstance());
  AttendanceCase_Attended_instance = new (AttendanceCase())('Attended', 5, 'Attended', VOID, VOID, VOID, true);
  AttendanceCase_AbsentExplained_instance = new (AttendanceCase())('AbsentExplained', 6, 'Explained absence', VOID, VOID, true);
  AttendanceCase_AbsentUnexplained_instance = new (AttendanceCase())('AbsentUnexplained', 7, 'Unexplained absence', VOID, VOID, false);
  AttendanceCase_AbsentBeforeExplained_instance = new (AttendanceCase())('AbsentBeforeExplained', 8, 'Explained before school absence', VOID, true, true, true);
  AttendanceCase_AbsentBeforeUnexplained_instance = new (AttendanceCase())('AbsentBeforeUnexplained', 9, 'Unexplained before school absence', VOID, true, false, true);
  AttendanceCase_AbsentAfterExplained_instance = new (AttendanceCase())('AbsentAfterExplained', 10, 'Explained after school absence', VOID, false, true, true);
  AttendanceCase_AbsentAfterUnexplained_instance = new (AttendanceCase())('AbsentAfterUnexplained', 11, 'Unexplained after school absence', VOID, false, false, true);
  if (Companion_instance_4 === VOID) {
    Companion_instance;
    new (Companion_3())();
  }
}
var AttendanceCase_ClosureHoliday_instance;
var AttendanceCase_ClosureFlexible_instance;
var AttendanceCase_ClosureProfessionalDevelopment_instance;
var AttendanceCase_ClosureEmergency_instance;
var AttendanceCase_ClosureUnapproved_instance;
var AttendanceCase_Attended_instance;
var AttendanceCase_AbsentExplained_instance;
var AttendanceCase_AbsentUnexplained_instance;
var AttendanceCase_AbsentBeforeExplained_instance;
var AttendanceCase_AbsentBeforeUnexplained_instance;
var AttendanceCase_AbsentAfterExplained_instance;
var AttendanceCase_AbsentAfterUnexplained_instance;
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_4 = this;
        var tmp = this;
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = get_entries_0();
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          if (!(element.closureReason_1 == null)) {
            destination.add_utx5q5_k$(element);
          }
        }
        tmp.closures_1 = toSet(destination);
        var tmp_0 = this;
        var tmp_1 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp_0.$cachedSerializer$delegate_1 = lazy(tmp_1, AttendanceCase$Companion$_anonymous__fpe26u);
      }
      forClosure_lt4mvc_k$(reason) {
        // Inline function 'kotlin.collections.single' call
        var single = null;
        var found = false;
        var _iterator__ex2g4s = get_entries_0().iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          if (equals(element.closureReason_1, reason)) {
            if (found)
              throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Collection contains more than one matching element.');
            single = element;
            found = true;
          }
        }
        if (!found)
          throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('Collection contains no element matching the predicate.');
        return single;
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  static_init_1();
  return Companion_instance_4;
}
function values_0() {
  static_init_1();
  return [AttendanceCase_ClosureHoliday_getInstance(), AttendanceCase_ClosureFlexible_getInstance(), AttendanceCase_ClosureProfessionalDevelopment_getInstance(), AttendanceCase_ClosureEmergency_getInstance(), AttendanceCase_ClosureUnapproved_getInstance(), AttendanceCase_Attended_getInstance(), AttendanceCase_AbsentExplained_getInstance(), AttendanceCase_AbsentUnexplained_getInstance(), AttendanceCase_AbsentBeforeExplained_getInstance(), AttendanceCase_AbsentBeforeUnexplained_getInstance(), AttendanceCase_AbsentAfterExplained_getInstance(), AttendanceCase_AbsentAfterUnexplained_getInstance()];
}
function get_entries_0() {
  static_init_1();
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_0());
  return $ENTRIES_0;
}
var $ENTRIES_0;
var AttendanceCaseClass;
function AttendanceCase() {
  if (AttendanceCaseClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName, closureReason, before, explained, atLeastPartialAttendance) {
        closureReason = closureReason === VOID ? null : closureReason;
        before = before === VOID ? null : before;
        explained = explained === VOID ? null : explained;
        atLeastPartialAttendance = atLeastPartialAttendance === VOID ? false : atLeastPartialAttendance;
        super(name, ordinal);
        this.displayName_1 = displayName;
        this.closureReason_1 = closureReason;
        this.before_1 = before;
        this.explained_1 = explained;
        this.atLeastPartialAttendance_1 = atLeastPartialAttendance;
      }
    }
    initMetadataForClass($, 'AttendanceCase', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_4});
    AttendanceCaseClass = $;
  }
  return AttendanceCaseClass;
}
var static_init_called_2;
function static_init_2() {
  if (static_init_called_2)
    return Unit_instance;
  static_init_called_2 = true;
  Kind_EN_instance = new (Kind())('EN', 0, 'Attended');
  Kind_EA_instance = new (Kind())('EA', 1, 'Explained absence');
  Kind_UA_instance = new (Kind())('UA', 2, 'Unexplained absence');
  Kind_BSEA_instance = new (Kind())('BSEA', 3, 'Explained before school absence, attended after school');
  Kind_BSUA_instance = new (Kind())('BSUA', 4, 'Unexplained before school absence, attended after school');
  Kind_ASEA_instance = new (Kind())('ASEA', 5, 'Explained after school absence, attended before school');
  Kind_ASUA_instance = new (Kind())('ASUA', 6, 'Unexplained after school absence, attended before school');
  Kind_IEN_instance = new (Kind())('IEN', 7, 'Attended, school closed');
  Kind_IFEA_instance = new (Kind())('IFEA', 8, 'Explained absence, school closed, full time');
  Kind_IFUA_instance = new (Kind())('IFUA', 9, 'Unexplained absence, school closed, full time');
  Kind_IPEA_instance = new (Kind())('IPEA', 10, 'Explained absence, school closed, part time');
  Kind_IPUA_instance = new (Kind())('IPUA', 11, 'Unexplained absence, school closed, part time');
  Kind_CF_instance = new (Kind())('CF', 12, 'Care location closed, full time placement');
  Kind_CP_instance = new (Kind())('CP', 13, 'Care location closed, part time placement');
  Kind_IC_instance = new (Kind())('IC', 14, 'Care location closed, school closed');
  Kind_UC_instance = new (Kind())('UC', 15, 'Unapproved closure');
}
var Kind_EN_instance;
var Kind_EA_instance;
var Kind_UA_instance;
var Kind_BSEA_instance;
var Kind_BSUA_instance;
var Kind_ASEA_instance;
var Kind_ASUA_instance;
var Kind_IEN_instance;
var Kind_IFEA_instance;
var Kind_IFUA_instance;
var Kind_IPEA_instance;
var Kind_IPUA_instance;
var Kind_CF_instance;
var Kind_CP_instance;
var Kind_IC_instance;
var Kind_UC_instance;
function values_1() {
  static_init_2();
  return [Kind_EN_getInstance(), Kind_EA_getInstance(), Kind_UA_getInstance(), Kind_BSEA_getInstance(), Kind_BSUA_getInstance(), Kind_ASEA_getInstance(), Kind_ASUA_getInstance(), Kind_IEN_getInstance(), Kind_IFEA_getInstance(), Kind_IFUA_getInstance(), Kind_IPEA_getInstance(), Kind_IPUA_getInstance(), Kind_CF_getInstance(), Kind_CP_getInstance(), Kind_IC_getInstance(), Kind_UC_getInstance()];
}
function MassachusettsAttendanceCode$Companion$$childSerializers$_anonymous__osc9ti() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.MassachusettsAttendanceCode.Kind', values_1());
}
var KindClass;
function Kind() {
  if (KindClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, meaning) {
        super(name, ordinal);
        this.meaning_1 = meaning;
      }
    }
    initMetadataForClass($, 'Kind');
    KindClass = $;
  }
  return KindClass;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      constructor() {
        Companion_instance_5 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [lazy(tmp_0, MassachusettsAttendanceCode$Companion$$childSerializers$_anonymous__osc9ti), null];
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  if (Companion_instance_5 === VOID)
    new (Companion_4())();
  return Companion_instance_5;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.MassachusettsAttendanceCode', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('kind', false);
        tmp0_serialDesc.addElement_5pzumi_k$('transport', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_dq00g4_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_5().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, tmp2_cached[0].get_value_j01efc_k$(), value.kind_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 1, value.transport_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_dq00g4_k$(encoder, value instanceof MassachusettsAttendanceCode() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = 0;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp7_cached = Companion_getInstance_5().$childSerializers_1;
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp7_cached[0].get_value_j01efc_k$(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeIntElement_941u6a_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp7_cached[0].get_value_j01efc_k$(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeIntElement_941u6a_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return MassachusettsAttendanceCode().new_org_thecommunitygroupinc_cares_MassachusettsAttendanceCode_76d534_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_5().$childSerializers_1[0].get_value_j01efc_k$(), IntSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
function Kind_EN_getInstance() {
  static_init_2();
  return Kind_EN_instance;
}
function Kind_EA_getInstance() {
  static_init_2();
  return Kind_EA_instance;
}
function Kind_UA_getInstance() {
  static_init_2();
  return Kind_UA_instance;
}
function Kind_BSEA_getInstance() {
  static_init_2();
  return Kind_BSEA_instance;
}
function Kind_BSUA_getInstance() {
  static_init_2();
  return Kind_BSUA_instance;
}
function Kind_ASEA_getInstance() {
  static_init_2();
  return Kind_ASEA_instance;
}
function Kind_ASUA_getInstance() {
  static_init_2();
  return Kind_ASUA_instance;
}
function Kind_IEN_getInstance() {
  static_init_2();
  return Kind_IEN_instance;
}
function Kind_IFEA_getInstance() {
  static_init_2();
  return Kind_IFEA_instance;
}
function Kind_IFUA_getInstance() {
  static_init_2();
  return Kind_IFUA_instance;
}
function Kind_IPEA_getInstance() {
  static_init_2();
  return Kind_IPEA_instance;
}
function Kind_IPUA_getInstance() {
  static_init_2();
  return Kind_IPUA_instance;
}
function Kind_CF_getInstance() {
  static_init_2();
  return Kind_CF_instance;
}
function Kind_CP_getInstance() {
  static_init_2();
  return Kind_CP_instance;
}
function Kind_IC_getInstance() {
  static_init_2();
  return Kind_IC_instance;
}
function Kind_UC_getInstance() {
  static_init_2();
  return Kind_UC_instance;
}
var MassachusettsAttendanceCodeClass;
function MassachusettsAttendanceCode() {
  if (MassachusettsAttendanceCodeClass === VOID) {
    class $ {
      constructor(kind, transport) {
        Companion_getInstance_5();
        this.kind_1 = kind;
        this.transport_1 = transport;
        var containsArg = this.transport_1;
        // Inline function 'kotlin.require' call
        if (!(0 <= containsArg ? containsArg <= 2 : false)) {
          var message = 'Transport is at most two ways, not ' + this.transport_1 + '.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
      }
      get_code_wok7xy_k$() {
        return this.kind_1.equals(Kind_UC_getInstance()) ? this.kind_1.name_1 : this.kind_1.name_1 + this.transport_1;
      }
      get_displayName_sscnb0_k$() {
        return this.get_code_wok7xy_k$() + ' - ' + this.kind_1.meaning_1;
      }
      toString() {
        return 'MassachusettsAttendanceCode(kind=' + this.kind_1.toString() + ', transport=' + this.transport_1 + ')';
      }
      hashCode() {
        var result = this.kind_1.hashCode();
        result = imul(result, 31) + this.transport_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MassachusettsAttendanceCode()))
          return false;
        if (!this.kind_1.equals(other.kind_1))
          return false;
        if (!(this.transport_1 === other.transport_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_MassachusettsAttendanceCode_76d534_k$(seen0, kind, transport, serializationConstructorMarker) {
        Companion_getInstance_5();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_2().descriptor_1);
        }
        var $this = createThis(this);
        $this.kind_1 = kind;
        $this.transport_1 = transport;
        var containsArg = $this.transport_1;
        // Inline function 'kotlin.require' call
        if (!(0 <= containsArg ? containsArg <= 2 : false)) {
          var message = 'Transport is at most two ways, not ' + $this.transport_1 + '.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        return $this;
      }
    }
    initMetadataForClass($, 'MassachusettsAttendanceCode', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
    MassachusettsAttendanceCodeClass = $;
  }
  return MassachusettsAttendanceCodeClass;
}
function CareTime_BeforeSchool_getInstance() {
  static_init_0();
  return CareTime_BeforeSchool_instance;
}
function CareTime_AfterSchool_getInstance() {
  static_init_0();
  return CareTime_AfterSchool_instance;
}
function CareTime_BeforeAndAfterSchool_getInstance() {
  static_init_0();
  return CareTime_BeforeAndAfterSchool_instance;
}
function CareTime_FullTime_getInstance() {
  static_init_0();
  return CareTime_FullTime_instance;
}
function CareTime_PartTime_getInstance() {
  static_init_0();
  return CareTime_PartTime_instance;
}
function AttendanceCase_ClosureHoliday_getInstance() {
  static_init_1();
  return AttendanceCase_ClosureHoliday_instance;
}
function AttendanceCase_ClosureFlexible_getInstance() {
  static_init_1();
  return AttendanceCase_ClosureFlexible_instance;
}
function AttendanceCase_ClosureProfessionalDevelopment_getInstance() {
  static_init_1();
  return AttendanceCase_ClosureProfessionalDevelopment_instance;
}
function AttendanceCase_ClosureEmergency_getInstance() {
  static_init_1();
  return AttendanceCase_ClosureEmergency_instance;
}
function AttendanceCase_ClosureUnapproved_getInstance() {
  static_init_1();
  return AttendanceCase_ClosureUnapproved_instance;
}
function AttendanceCase_Attended_getInstance() {
  static_init_1();
  return AttendanceCase_Attended_instance;
}
function AttendanceCase_AbsentExplained_getInstance() {
  static_init_1();
  return AttendanceCase_AbsentExplained_instance;
}
function AttendanceCase_AbsentUnexplained_getInstance() {
  static_init_1();
  return AttendanceCase_AbsentUnexplained_instance;
}
function AttendanceCase_AbsentBeforeExplained_getInstance() {
  static_init_1();
  return AttendanceCase_AbsentBeforeExplained_instance;
}
function AttendanceCase_AbsentBeforeUnexplained_getInstance() {
  static_init_1();
  return AttendanceCase_AbsentBeforeUnexplained_instance;
}
function AttendanceCase_AbsentAfterExplained_getInstance() {
  static_init_1();
  return AttendanceCase_AbsentAfterExplained_instance;
}
function AttendanceCase_AbsentAfterUnexplained_getInstance() {
  static_init_1();
  return AttendanceCase_AbsentAfterUnexplained_instance;
}
//region block: exports
export {
  AttendanceCase_Attended_getInstance as AttendanceCase_Attended_getInstance2ikeef3q5e60n,
  CareTime_FullTime_getInstance as CareTime_FullTime_getInstance2puuq5c8w5gwp,
  CareTime_PartTime_getInstance as CareTime_PartTime_getInstance3kqj07ymkbbng,
  Type_BeforeAfter_getInstance as Type_BeforeAfter_getInstance1cykxa2neckgn,
  Type_PartFull_getInstance as Type_PartFull_getInstance1qsztgbc7u19t,
  $serializer_getInstance as $serializer_getInstance3tvk07wc79lhi,
  Companion_getInstance_1 as Companion_getInstance27kcs909wdme9,
  Companion_getInstance_0 as Companion_getInstance1exe5oe9i5w84,
  Companion_getInstance_3 as Companion_getInstance1ts49hpe5lvz6,
  Companion_getInstance_2 as Companion_getInstance3lyiwdpjexugx,
  ActualAttendance as ActualAttendance3tb4czhk5mikp,
  get_entries as get_entries3dia5qzc4pxls,
  ScheduledAttendance as ScheduledAttendance2v6gob50ik295,
};
//endregion

//# sourceMappingURL=attendance.mjs.map
